export const isEligibleForSendConfirmation = (order, user) => {
  if (!user?.vendor?.usesConfirmIt) return false;
  if (!order) return false;
  if (!["New", "Sold Out"].includes(order.status)) return false;
  if (order.confirmedAt) return false;
  if (order.financialStatus === "Paid") return false;
  // SDD / Blink orders are auto-confirmed and never go to ConfirmIt.
  if (order.sameDayDelivery || order.sddRequested || order.blinkTrackingId) return false;
  return true;
};
